<template>
  <div>
    <div class="block">
      <span class="demonstration">默认</span>
      <el-date-picker
        v-model="value1"
        type="datetime"
        placeholder="选择日期时间">
      </el-date-picker>
    </div>
    <button @click="a">a</button>
    <input v-model="input" type="text">
    {{this.coo.a}}    {{this.coo.b}}
    <loading></loading>
  </div>
</template>

<script>
  export default {
    name: 'demo123',
    components:{
    },
    data() {
      return {
        value1: "",
        input:"123"
      }
    },
    computed:{
      coo(){
        console.log("coo")
        let b= this.input +"1"
        return {a:this.input,b}
      }
    },
    methods:{
      a(){
        // ?auth_token=9cad7505-55fd-450d-8abb-12abadd980ed&page_no=1&page_size=10&is_latest=true
        this.$alert('qwe')
        let params={
          auth_token:'9cad7505-55fd-450d-8abb-12abadd980ed'
        }
        this.$http.get('/dashboard/devices',{params}).then(data=>{
          console.log(data)
        })
        // this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   this.$message({
        //     type: 'success',
        //     message: '删除成功!'
        //   });
        // }).catch(() => {
        //   this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        //   });
        // });
      }
    }

  }
</script>

<style type="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/view/demo.vue